import { getAxiosInstance } from '../../configs/axios-config';
import { authDetails } from '../../helpers/auth-details';
var constants = require("../../configs/constants");

const GET_SOC_INTERNAL_NOTIFICATION_PROGRESS = "GET_SOC_INTERNAL_NOTIFICATION_PROGRESS";
const GET_SOC_INTERNAL_NOTIFICATION_SUCCESS = "GET_SOC_INTERNAL_NOTIFICATION_SUCCESS";
const GET_SOC_INTERNAL_NOTIFICATION_FAILURE = "GET_SOC_INTERNAL_NOTIFICATION_FAILURE";

const ADD_SOC_INTERNAL_NOTIFICATION_PROGRESS = "ADD_SOC_INTERNAL_NOTIFICATION_PROGRESS";
const ADD_SOC_INTERNAL_NOTIFICATION_SUCCESS = "ADD_SOC_INTERNAL_NOTIFICATION_SUCCESS";
const ADD_SOC_INTERNAL_NOTIFICATION_FAILURE = "ADD_SOC_INTERNAL_NOTIFICATION_FAILURE";

const UPDATE_SOC_INTERNAL_NOTIFICATION_PROGRESS = "UPDATE_SOC_INTERNAL_NOTIFICATION_PROGRESS";
const UPDATE_SOC_INTERNAL_NOTIFICATION_SUCCESS = "UPDATE_SOC_INTERNAL_NOTIFICATION_SUCCESS";
const UPDATE_SOC_INTERNAL_NOTIFICATION_FAILURE = "UPDATE_SOC_INTERNAL_NOTIFICATION_FAILURE";

const DELETE_SOC_INTERNAL_NOTIFICATION_PROGRESS = "DELETE_SOC_INTERNAL_NOTIFICATION_PROGRESS";
const DELETE_SOC_INTERNAL_NOTIFICATION_SUCCESS = "DELETE_SOC_INTERNAL_NOTIFICATION_SUCCESS";
const DELETE_SOC_INTERNAL_NOTIFICATION_FAILURE = "DELETE_SOC_INTERNAL_NOTIFICATION_FAILURE";

/**
 *  Get society internal notification
*/
export const getSocietyInternalNotifications = (data) => (dispatch) => {
    var user = authDetails();
    let axiosInstance = getAxiosInstance();

    dispatch({ type: GET_SOC_INTERNAL_NOTIFICATION_PROGRESS });

    return axiosInstance.get(constants.api.GET_SOC_INTERNAL_NOTIFICATION,
        { params: { perpage: data.perpage, page: data.page, societyId: data.societyId, userId: user.userId } })
        .then(function (response) {
            dispatch({
                type: GET_SOC_INTERNAL_NOTIFICATION_SUCCESS,
                internalNotifications: response.data.dataList, totalRowsCount: response.data.totalItems
            });
        }).catch(function (error) {
            dispatch({ type: GET_SOC_INTERNAL_NOTIFICATION_FAILURE, message: error.response.data.message });
        });
};

/**
 * Add internal notification
 * @param {object}
 */
export const addInternalNotification = (data) => (dispatch) => {
    var user = authDetails();
    let axiosInstance = getAxiosInstance();
    dispatch({ type: ADD_SOC_INTERNAL_NOTIFICATION_PROGRESS });

    return axiosInstance.post(constants.api.ADD_SOC_INTERNAL_NOTIFICATION, {
        title: data.title,
        description: data.description,
        userId: user.userId,
        societyId: user.userId
    }).then(function (response) {
        dispatch({ type: ADD_SOC_INTERNAL_NOTIFICATION_SUCCESS, message: response.data.message });
    }).catch(function (error) {
        dispatch({ type: ADD_SOC_INTERNAL_NOTIFICATION_FAILURE, message: error.response.data.message });
    });
};

/**
 * Update internal notification
 * @param {object}
 */
export const updateInternalNotification = (data) => (dispatch) => {
    var user = authDetails();
    let axiosInstance = getAxiosInstance();
    dispatch({ type: UPDATE_SOC_INTERNAL_NOTIFICATION_PROGRESS });

    return axiosInstance.put(constants.api.UPDATE_SOC_INTERNAL_NOTIFICATION, {
        title: data.title,
        description: data.description,
        internalNotificationId: data.internalNotificationId,
        userId: user.userId
    }).then(function (response) {
        dispatch({ type: UPDATE_SOC_INTERNAL_NOTIFICATION_SUCCESS, message: response.data.message });
    }).catch(function (error) {
        dispatch({ type: UPDATE_SOC_INTERNAL_NOTIFICATION_FAILURE, message: error.response.data.message });
    });
};

/**
 * Delete internal notification
 * @param {object}
 */
export const deleteInternalNotification = (internalNotificationId) => (dispatch) => {

    var user = authDetails();
    let axiosInstance = getAxiosInstance();

    dispatch({ type: DELETE_SOC_INTERNAL_NOTIFICATION_PROGRESS });

    return axiosInstance.patch(constants.api.DELETE_SOC_INTERNAL_NOTIFICATION, {
        internalNotificationId: internalNotificationId,
        userId: user.userId
    }).then(function (response) {
        dispatch({ type: DELETE_SOC_INTERNAL_NOTIFICATION_SUCCESS, message: response.data.message });
    }).catch(function (error) {
        dispatch({ type: DELETE_SOC_INTERNAL_NOTIFICATION_FAILURE, message: error.response.data.message });
    });
};


/**
* render the delete user modal 
* @param {boolen & object}, true, delete user id
*/
export const showDeleteModal = (deleting, internalNotificationId) => (dispatch) => {
    dispatch({ type: 'DELETE_INTERNAL_NOTIFICATION_CASE', deleting: deleting, internalNotificationId: internalNotificationId });
};

/**
 * Render the component using switch case
 * @param {String,boolean,object}, aboutData(object)
 */
export const renderSwitch = (choice, editing, internalNotification) => (dispatch) => {
    dispatch({ type: "SEND_CASE_NOTIFICATION", choice: choice, editing: editing, internalNotification: internalNotification });
};

export const initialState = {
    fetching: false,
    adding: false,
    editing: false,
    deleting: false,
    actionPerformed: false,
    message: '',
    internalNotifications: [],
    internalNotification: null,
    internalNotificationId:'',
    choice: 'table',
    totalRowsCount: 0
}

export default (state = initialState, action) => {
    switch (action.type) {
        case GET_SOC_INTERNAL_NOTIFICATION_PROGRESS:
            return { ...state, fetching: true,  actionPerformed: false };
        case GET_SOC_INTERNAL_NOTIFICATION_SUCCESS:
            return {
                ...state, internalNotifications: action.internalNotifications, totalRowsCount: action.totalRowsCount, fetching: false,
                actionPerformed: false
            };
        case GET_SOC_INTERNAL_NOTIFICATION_FAILURE:
            return { ...state, message: action.message, fetching: false };

        case ADD_SOC_INTERNAL_NOTIFICATION_PROGRESS:
            return { ...state, adding: true,  actionPerformed: false };
        case ADD_SOC_INTERNAL_NOTIFICATION_SUCCESS:
            return { ...state, message: action.message, adding: false, choice: 'table', actionPerformed: true };
        case ADD_SOC_INTERNAL_NOTIFICATION_FAILURE:
            return { ...state, message: action.message, adding: false };

        case UPDATE_SOC_INTERNAL_NOTIFICATION_PROGRESS:
            return { ...state, editing: true ,  actionPerformed: false};
        case UPDATE_SOC_INTERNAL_NOTIFICATION_SUCCESS:
            return { ...state, message: action.message, editing: false, choice: 'table', actionPerformed: true };
        case UPDATE_SOC_INTERNAL_NOTIFICATION_FAILURE:
            return { ...state, message: action.message, editing: false };

        case DELETE_SOC_INTERNAL_NOTIFICATION_PROGRESS:
            return { ...state, deleting: true,  actionPerformed: false };
        case DELETE_SOC_INTERNAL_NOTIFICATION_SUCCESS:
            return { ...state, message: action.message, deleting: false, actionPerformed: true };
        case DELETE_SOC_INTERNAL_NOTIFICATION_FAILURE:
            return { ...state, message: action.message, deleting: false };

        case 'DELETE_INTERNAL_NOTIFICATION_CASE':
            return { ...state, internalNotificationId: action.internalNotificationId, deleting: action.deleting, delete: true };

        case 'SEND_CASE_NOTIFICATION':
            return { ...state, choice: action.choice, editing: action.editing, internalNotification: action.internalNotification };
        // case HIDE_ABOUT_SNACKBAR:
        //     return { ...state, open: false };
        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/reducers/society/internal-notification-reducer.js